/* eslint-disable no-console */
import {
  get, isEmpty, includes, each,
} from 'lodash';

export default class AnalyticsEvent {
  constructor({
    category, name, data, services, fbTrackMethod, fbContentIds, fbAdditionalProperties, gaEventLabel, gaEcommerceProperties, shouldReIdentifyUser, identity,
  }) {
    try {
      if (
        !category || isEmpty(category)
                || !name || isEmpty(name)
                || !services || isEmpty(services)
      ) {
        new Error('invalid analytics event data');
      }

      this.category = category;
      this.name = name;
      this.data = data || {};
      this.services = services;
      this.fbTrackMethod = fbTrackMethod;
      this.fbContentIds = fbContentIds;
      this.fbAdditionalProperties = fbAdditionalProperties;
      this.gaEventLabel = gaEventLabel;
      this.gaEcommerceProperties = gaEcommerceProperties;
      this.shouldReIdentifyUser = shouldReIdentifyUser;
      this.identity = identity;
      this.validateCategory();
      this.validateServices();
      this.validateFbTrackMethod();
    } catch (e) {
      console.error(e.toString(), this);
    }
  }

  get validServices() {
    return get(window, 'TIS.analytics.validServices', {});
  }

  get validCategories() {
    return get(window, 'TIS.analytics.validCategories', {});
  }

  get validFbTrackMethods() {
    return get(window, 'TIS.analytics.validFbTrackMethods', {});
  }

  validateFbTrackMethod() {
    if (!includes(this.services, 'fb')) {
      return;
    }

    if (isEmpty(this.fbTrackMethod)) {
      new Error('unspecified fb track method for event');
    }

    if (!includes(this.validFbTrackMethods, this.fbTrackMethod)) {
      new Error(`invalid fb track method: ${this.fbTrackMethod}`);
    }
  }

  validateCategory() {
    if (!includes(this.validCategories, this.category)) {
      new Error(`invalid analytics category: ${this.category}`);
    }
  }

  validateServices() {
    each(this.services, (service) => {
      if (!includes(this.validServices, service)) {
        new Error(`invalid analytics services: ${this.services}`);
      }
    });
  }
}
